export const BillingTypes = {
    FIXED_PRICE: 'FIXED_PRICE',
    TIME: 'TIME',
};
